/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterTSmall = createReactComponent("letter-t-small", "IconLetterTSmall", [
  ["path", { d: "M10 8h4", key: "svg-0" }],
  ["path", { d: "M12 8v8", key: "svg-1" }]
]);

export { IconLetterTSmall as default };
//# sourceMappingURL=IconLetterTSmall.js.map
